import {
  FC,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";

import { Snackbar, SnackBarType } from "@repo/edtech-ui-kit";

import { SnackbarContext } from "./snackbar-context";
import { SnackbarMessage } from "./types";

import st from "./SnackbarProvider.module.scss";

export const SnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [ snackbars, setSnackbars ] = useState<SnackbarMessage[]>([]);

  const showSnackbar = useCallback((
    message: string, type?: SnackBarType, subText?: string,
  ) => {
    const newSnackbar: SnackbarMessage = {
      id: Date.now(),
      message,
      type,
      subText,
    };
    setSnackbars((prev) => [ ...prev, newSnackbar ]);

    setTimeout(() => {
      setSnackbars((prev) =>
        prev.filter((snackbar) => snackbar.id !== newSnackbar.id));
    }, 3000);
  },
  []);

  const contextValue = useMemo(() => ({
    showSnackbar,
  }), [ showSnackbar ]);

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      <div className={st.container}>
        {
          snackbars.map(({
            id,
            message,
            type,
            subText,
          }) => (
            <Snackbar
              key={id}
              message={message}
              subText={subText}
              type={type}
              onClose={
                () =>
                  setSnackbars((prev) =>
                    prev.filter((snackbar) => snackbar.id !== id))
              }
            />
          ))
        }
      </div>
    </SnackbarContext.Provider>
  );
};
